import { Button } from '@mui/material';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import { baseCell, dateCell } from 'components/cells';
import { useTranslation } from 'react-i18next';

export function useTransportDocumentUniqueFieldsColumns(
  handleUpdate?: (row: any) => void
): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'actions',
      type: 'actions',
      width: 125,
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        const handleClick = () => {
          if (handleUpdate) {
            handleUpdate(params.row);
          }
        };

        return [
          <Button key="select-button" onClick={handleClick} variant="contained" color="primary">
            {t('global.move')}
          </Button>
        ];
      }
    } as GridColDef,
    {
      field: 'ref',
      headerName: t(`global.document`),
      width: 125,
      filterable: false,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      type: 'text',
      flex: 200,
      filterable: false,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'order',
      headerName: t(`global.order`),
      width: 150,
      type: 'text',
      filterable: false,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'date',
      headerName: t(`global.date`),
      width: 100,
      type: 'date',
      valueGetter: ({ value }) => (value ? new Date(value) : null),
      filterable: false,
      sortable: false,
      renderCell: dateCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      width: 200,
      type: 'string',
      filterable: false,
      sortable: false,
      renderCell: baseCell
    }
  ];
  return columns;
}
